<template>
    <div class="modal" :class="{'is-active':isActive}">
        <div class="modal-background" @click="close(false)"></div>
        <transition name="fade" mode="out-in">
            <div class="modal-card" v-if="isActive">
                <header class="modal-card-head">
                    <button class="delete" aria-label="close" @click="close(false)"></button>
                </header>
                <section class="modal-card-body">
                    <p>
                        Zapisz się na najbliższe śniadanie podatkowo-prawne!
                    </p>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="close(true)">Zapisz się!</button>
                </footer>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data(){
        return {
            isActive: false
        }
    },
    methods: {
        close(scrollTo){
            this.isActive = false
            if(scrollTo){
                if(this.$route.name != 'home'){
                    this.$router.push('/#najblizsze-sniadania')
                } else {
                    this.$scrollTo('#najblizsze-sniadania')
                }
            }
        }
    },
    created(){
        setTimeout(() => {
            this.isActive = true
        }, 3000)
        window.addEventListener("keydown",() => {
            this.isActive = false
        })
    }
}
</script>

<style lang="sass">
@import "@/styles/framework/variables.sass"
@import "@/styles/framework/extends.sass"
.modal
    .modal-card
        .modal-card-head
            justify-content: flex-end
        .modal-card-body
            text-align: center
            p
                font-size: 1.75rem
                color: $blue1
        .modal-card-foot
            button
                margin: auto
</style>
